import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const LocalizationKeysRoutes: Routes = [
  {
    path: "localization-keys",
    loadComponent: () =>
      import("./localization-keys/localization-keys.component").then(
        (m) => m.LocalizationKeysComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./localization-keys-list/localization-keys-list.component").then(
            (m) => m.LocalizationKeysListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./localization-keys-form/localization-keys-form.component").then(
            (m) => m.LocalizationKeysFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./localization-keys-form/localization-keys-form.component").then(
            (m) => m.LocalizationKeysFormComponent,
          ),
      },
    ],
  },
];
